const STROKE_SCALE_FACTOR = 10;

type CircleShapeProps = {
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
  borderRadius?: number;
  lockAspectRatio?: boolean;
} & React.SVGProps<SVGSVGElement>;

const CircleShapeComponent: React.FC<CircleShapeProps> = ({
  fill = 'none',
  width = 200,
  height = 200,
  stroke = 'none',
  strokeWidth = 0,
  borderRadius: _borderRadius,
  lockAspectRatio: _lockAspectRatio,
  ...rest
}) => {
  const scaledStrokeWidth = strokeWidth * STROKE_SCALE_FACTOR;
  const inset = scaledStrokeWidth / 2;

  const outerCx = width / 2;
  const outerCy = height / 2;
  const outerRx = (width - scaledStrokeWidth) / 2;
  const outerRy = (height - scaledStrokeWidth) / 2;

  const innerCx = width / 2;
  const innerCy = height / 2;
  const innerRx = Math.max(0, outerRx - inset);
  const innerRy = Math.max(0, outerRy - inset);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <ellipse cx={outerCx} cy={outerCy} rx={outerRx} ry={outerRy} fill="none" stroke={stroke} strokeWidth={scaledStrokeWidth} />
      <ellipse cx={innerCx} cy={innerCy} rx={innerRx} ry={innerRy} fill={fill} stroke="none" />
    </svg>
  );
};

export default CircleShapeComponent;
